import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";
import "../css/app.css";
import "primeicons/primeicons.css";
import { ZiggyVue, route } from "../../vendor/tightenco/ziggy/src/js";
import { Ziggy } from "./ziggy";
import AppSetup from "./init";

// After a deploy the old hashed chunks are gone; when a stale tab fails to
// lazy-load one, force a single reload to pick up the new build. The
// sessionStorage guard prevents a reload loop if the asset is truly missing.
window.addEventListener("vite:preloadError", (event) => {
    const last = Number(sessionStorage.getItem("vite-preload-reload-at") ?? 0);
    if (Date.now() - last < 30_000) return;
    sessionStorage.setItem("vite-preload-reload-at", String(Date.now()));
    event.preventDefault();
    window.location.reload();
});

// Expose route() globally (replaces the @routes blade directive), same as www.
window.Ziggy = Ziggy;
window.route = (name: string, params?: any, absolute: boolean = false) =>
    route(name, params, absolute, Ziggy);

createInertiaApp({
    resolve: (name: string) => {
        const pages = import.meta.glob("./Pages/**/*.vue");
        return pages[`./Pages/${name}.vue`]();
    },
    setup({ el, App, props, plugin }) {
        createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue, Ziggy)
            .use(AppSetup, { props })
            .mount(el);
    },
    progress: {},
});
